import React from 'react'

const Skills = () => (
  <div>
    <div className="row skill">
      <div className="three columns header-col">
        <h1>
          <span>Skills</span>
        </h1>
      </div>

      <div className="nine columns main-col">
        <p>
          My strengths, based off of past performance and the appraisal of
          colleagues:
        </p>
      </div>
    </div>

    <div className="row skill">
      <div className="three columns header-col">
        <h1>
          <span>Professional</span>
        </h1>
      </div>

      <div className="nine columns main-col">
        <div className="bars">
          <ul className="skills">
            <li>
              <span className="bar-expand entrepreneurship" />
              <em>Entrepreneurship</em>
            </li>
            <li>
              <span className="bar-expand software" />
              <em>Software Engineering</em>
            </li>
            <li>
              <span className="bar-expand mgmt" />
              <em>Engineering Management</em>
            </li>
            <li>
              <span className="bar-expand product" />
              <em>Product Development</em>
            </li>
            <li>
              <span className="bar-expand hiring" />
              <em>Hiring</em>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="row skill">
      <div className="three columns header-col">
        <h1>
          <span>Technical</span>
        </h1>
      </div>

      <div className="nine columns main-col">
        <div className="bars">
          <ul className="skills">
            <li>
              <span className="bar-expand javascript" />
              <em>JavaScript - ES6/7 | React.js | Node.js</em>
            </li>
            <li>
              <span className="bar-expand markup" />
              <em>Markup - HTML5 | CSS | Styled-Components</em>
            </li>
            <li>
              <span className="bar-expand go" />
              <em>Golang</em>
            </li>
            <li>
              <span className="bar-expand database" />
              <em>DBs - PostgreSQL | MySQL | MongoDB</em>
            </li>
            <li>
              <span className="bar-expand devops" />
              <em>DevOps - AWS | Docker | Gitlab | Terraform</em>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)

export default Skills



// WEBPACK FOOTER //
// ./src/components/Skills.js